import {PeriodTabID} from '../../types';
import {Item} from './types';

export const items: Item[] = [
	{value: PeriodTabID.SchoolYear, label: 'Current school year'},
	{value: PeriodTabID.MarkingPeriod, label: 'Marking Period'},
];
